import {Form, FormikProps} from "formik";
import useQuery from "../../../hook/useQuery";
import {useHistory} from "react-router-dom";
import useToastNotify from "../../../hook/useToastNotify";
import React, {useEffect, useState} from "react";
import {ISelectOptionsItem} from "../../../contracts/select_options";
import httpClient from "../../../services/httpClient";
import {couponsApi} from "../../../constans/apiUrls";
import Loading from "../../Elements/Loading/Loading";
import Input from "../../Elements/Form/Input";
import InputSelect from "../../Elements/Form/InputSelect";
import Button from "../../Elements/Button";
import {
    generateCouponValueTypeTitle
} from "../../../helpers/functions";
import {ICouponData} from "../../../contracts/data/coupon";
import {CouponsValueType} from "../../../constans/enumTypes";

const InnerCouponForm = (props: FormikProps<ICouponData>) => {
    const queryParams = useQuery()
    const history = useHistory()
    const {toastNotify} = useToastNotify()
    const [loading, setLoading] = useState<boolean>(true)
    const optionsValueType:Array<ISelectOptionsItem> = [
        {value: CouponsValueType.PRICE, label:generateCouponValueTypeTitle(CouponsValueType.PRICE)},
        {value: CouponsValueType.PERCENT, label:generateCouponValueTypeTitle(CouponsValueType.PERCENT)},
    ]

    const handleFetchPrevData = async () => {
        await httpClient().get(`${couponsApi.update}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200){
                    props.setValues(response?.data?.data)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if(props.status.formType === 'edit' && queryParams.get('id')){
            handleFetchPrevData()
        }else {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        if(props?.status?.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
            if(props.status?.result?.status === 'success'){
                history.replace('/dashboard/coupons/list')
            }
        }
    }, [props.status])

    return (
        <React.Fragment>
            {loading ? <Loading />:
                <Form>
                    <div className={"w-3/5"}>
                        <Input name={"title"} label={"عنوان کد تخفیف"} placeholder={"عنوان..."} isRequired
                               meta={props.getFieldMeta('title')} defaultValue={props.values?.title}/>
                        <Input name={"hash"} label={"کد تخفیف"} placeholder={"کد..."} isRequired
                               meta={props.getFieldMeta('hash')} defaultValue={props.values?.hash}/>
                        <Input name={"stock"} type={"number"} label={"تعداد استفاده از کد"} placeholder={"تعداد..."}
                               meta={props.getFieldMeta('stock')} defaultValue={props.values?.stock} isRequired/>
                        <Input name={"expired_day"} type={"number"} label={"مدت اعتبار کد (روز)"} placeholder={"مدت اعتبار..."} isRequired
                               meta={props.getFieldMeta('expired_day')} defaultValue={props.values?.expired_day}/>
                        <InputSelect name={'coupon_type'} label={'نوع محاسبه مقدار کد'}
                                     placeholder={'نوع محاسبه مقدار کد...'}
                                     handleSetValue={(values: any) => props.setFieldValue('coupon_type', values)}
                                     options={optionsValueType} isMultiple={false} error={props?.errors?.coupon_type} // props?.errors?.type!
                                     meta={props.getFieldMeta('coupon_type')}
                                     defaultValue={optionsValueType.find((item, _) => item.value === props?.values?.coupon_type)}
                                     isRequired
                        />
                        <Input name={"value"} type={"number"} label={"مقدار کد تخفیف"} placeholder={"مقدار..."} isRequired
                               meta={props.getFieldMeta('value')} defaultValue={props.values?.value}
                               subContent={"اگر نوع محاسبه شما بر حسب قیمت است لطفا قیمت را به ریال و اگر بر حسب درصد است مقدار را بین 0 تا 100 وارد نمایید"}
                        />
                        <Input name={"high_discount"} label={"سقف کد تخفیف (ریال)"} placeholder={"سقف کد تخفیف (ریال)..."}
                               meta={props.getFieldMeta('high_discount')} defaultValue={props.values?.high_discount}
                               subContent={"اگر برای کد تخفیف خود سقف هزینه مد نظر دارید، مقدار را به ریال وارد نمایید در غیر اینصورت صفر قرار دهید"}
                        />
                        <Input name={"low_price"} label={"کف خرید (ریال)"} placeholder={"کف خرید (ریال)..."}
                               meta={props.getFieldMeta('low_price')} defaultValue={props.values?.low_price}
                               subContent={"اگر برای کد تخفیف خودکف خرید مد نظر دارید، مقدار را به ریال وارد نمایید در غیر اینصورت صفر قرار دهید"}
                        />
                        <Input name={"user_mobile"} label={"کد برای یک کاربر خاص"} placeholder={"شماره موبایل..."}
                               meta={props.getFieldMeta('user_mobile')} defaultValue={props.values?.user_mobile}
                               subContent={"اگر میخواهید کد مختص یک کاربر مشخص باشد، لطفا شماره موبایل آن کاربر را وارد نمایید"}
                        />
                    </div>
                    <div className={"text-left"}>
                        <Button title={props.status?.formType === 'create' ? "ثبت کد تخفیف جدید" : "بروزرسانی کد تخفیف"} isLoading={props.isSubmitting}/>
                    </div>
                </Form>}
        </React.Fragment>
    )
}

export default InnerCouponForm